module.exports = __webpack_public_path__ + "static/wpack/extracted/penguin-paird04140171566301fd691fac6914122f5.svg";